import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpPerformanceReportPrintPage } from '@/features/pcmp/pages/PcmpPerformanceReportPrintPage';
import { pcmpReportSearchSchema } from '@/features/pcmp/types/pcmpReports.types';

export const Route = createFileRoute('/_print/pcmp/reports/performance/print')({
  validateSearch: pcmpReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Performance Report">
      <PcmpPerformanceReportPrintPage />
    </ErrorBoundary>
  ),
});
